module.exports = __webpack_public_path__ + "static/media/deepseek.947a6e77.svg";